<template>
  <article class="popup reinvite-popup">
    {{$t('popups.addUser.success')}}
    <close-btn></close-btn>
  </article>
</template>

<script>
  import closeBtn from '../closeBtn'
  import {popups} from "../../../mixins/popups";

  export default {
    name: 'reinvitePopup',
    mixins: [popups],
    components: {
      closeBtn
    }
  }
</script>
